import { signal } from "../../utils/signal";
import { Progress, readProgress } from "./api";

/**
 * The one copy of /lifecycle/me on a page. The billing strip, the checklist and
 * the post-checkout page all read it, so a product page makes one request.
 */
export const progressSignal = signal<Progress | null>(null);

let inFlight: Promise<Progress | null> | null = null;

export function loadProgress(force = false): Promise<Progress | null> {
  if (!force && progressSignal.peek()) {
    return Promise.resolve(progressSignal.peek());
  }
  if (inFlight) return inFlight;
  inFlight = readProgress()
    .then((progress) => {
      progressSignal.value = progress;
      return progress;
    })
    .catch(() => null)
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}

export function setProgress(progress: Progress): void {
  progressSignal.value = progress;
}

export function clearProgress(): void {
  progressSignal.value = null;
}
